import { html } from 'lit';
const TwitterDuotone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill="#000" d="M17.463 3.4h2.914l-6.365 7.275 7.488 9.899h-5.863l-4.592-6.004-5.255 6.004H2.875l6.809-7.782L2.5 3.4h6.012l4.15 5.488zm-1.022 15.43h1.614L7.635 5.052H5.903z"/>
  </svg>
`;
export default TwitterDuotone;
